import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import { createPinia } from 'pinia'
import { MotionPlugin } from '@vueuse/motion';
import router from './router'
import "@/assets/scss/style.scss"

const app = createApp(App)
const pinia = createPinia();

app.use(router).use(pinia).use(MotionPlugin).mount('#app');
